/******************************************************************************************
 *	Reseller Org Factory
 ******************************************************************************************/
(function() {


  angular.module('rcServices.resellerOrg', []).factory(
    'ResellerOrg',
    /* @ngInject */
    function(_, Settings, feature) {
      function ResellerOrg(data) {
        this.id = data.id;
        this.externalSalesContractId = data.externalSalesContractId;
        this.name = data.name;
        this.address = data.address;
        this.primaryAdmin = data.primaryAdmin;
        this.countryCode = _.get(this.address, 'country.countryCode');

        //If region is set to "default region", set the translation key
        if (_.get(this.address, 'region.regionCode') === Settings.DEFAULT_REGION_CODE) {
          this.address.region.regionNameKey = 'generic.defaultRegion';
        }

        this.isChinaReseller = _.get(this.address, 'country.countryCode') === 'CN';
        this.isResellerCountryCanViewBanner = !(this.countryCode === 'BY' || this.countryCode === 'RU' || this.countryCode === 'CN');
        this.allowedMarketSegments = _.isNil(data.allowedMarketSegments) ? [] : data.allowedMarketSegments;
        this.allowedCountries = _.isNil(data.allowedCountries) ? [] : data.allowedCountries;
        // eslint-disable-next-line lodash/prefer-lodash-method
        const countryIsAllowed = this.allowedCountries.includes(this.countryCode);
        const hasAllowedMarketSegments = this.allowedMarketSegments.length > 0;
        this.isResellerAllowlisted = feature.isEnabled("temp_restrict_vip_creation_edu_gov") ? (countryIsAllowed || hasAllowedMarketSegments) : true;

      }

      ResellerOrg.prototype.isResellerCanViewEduGovBanner = function() {
        return feature.isEnabled('temp_enable_sunset_banner_edu_gov');
      };
      return ResellerOrg;
    }
  );
})();
